import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import rootReducer from 'modules';

export const history = createBrowserHistory();

const defaultState = {}
const enhancers = []
const middleware = [
  thunk,
  routerMiddleware(history)
]

if (['local', 'development', 'staging'].includes(process.env.REACT_APP_ENV)) {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  if (typeof devToolsExtension === 'function') enhancers.push(devToolsExtension());
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const stores = createStore(
  rootReducer,
  defaultState,
  composedEnhancers
);

export default stores;